"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var node_html_parser_1 = require("node-html-parser");

var CMSIconContext_1 = require("./CMSIconContext");

var useAllCMSIcons = function useAllCMSIcons() {
  var iconsQuery = (0, react_1.useContext)(CMSIconContext_1.IconsContext);
  if (!iconsQuery) iconsQuery = {
    iconsQuery: {
      nodes: []
    }
  };
  var nodes = iconsQuery.iconsQuery.nodes;
  var icons = (0, react_1.useMemo)(function () {
    return nodes.map(function (node) {
      return {
        name: node.data.Name,
        svg: (0, node_html_parser_1.parse)(node.data.SVG.localFiles[0].childSvg.svgString),
        text: node.data.Text
      };
    });
  }, [nodes]);
  return icons;
};

exports.default = useAllCMSIcons;